import * as z from 'zod';

export const sendMessageToCustomTileSchema = z.object({
  name: z.string(),
  event: z.string().optional(),
  origin: z.string().optional(),
  data: z.any().optional(),
});

export const mobileScreenshareStreamSchema = z.object({
  type: z.enum(['audio', 'video']),
  mid: z.string(),
});

export const validationMobileScreenshareDataSchema = z.object({
  feedId: z.string(),
  streams: z.array(mobileScreenshareStreamSchema),
});
